import React from "react";
import "./CubeSheetCard.scss"
import { MovePaperWorkCard } from "components/movePaperWorkCard";
import { MoveListCard } from "components/moveListCard";
import { Button } from "components/button";
import { EstimatorDetailCard } from "components/estimatorDetailCard";
import { OrignCompanyDetailCard } from "components/OrignCompanyDetailCard";
import { CompanyDetailCard } from "components/companyDetailCard";
import { DestinationCompanyDetailCard } from "components/DestinationCompanyDetailCard";
import { InfoCard } from "components/infoCard";
import { CardLayout } from "components/cardLayout";
import { getEstFlowEstimateDetails, getEstimatorInventory } from "../../core/services/moveDetailsByCustomer"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
//@ts-ignore
// import SimpleLineIcon from 'react-simple-line-icons';
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import { MdClose } from "react-icons/md";
//@ts-ignore
import SignatureCanvas from 'react-signature-canvas'
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { navigate } from "@reach/router";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Spinner from '../spinner/spinner';
//import { sign } from "crypto";

export interface CubeSheetCardrops {

}

export interface CubeSheetCardState {
    loading: boolean
    data: any
    transportData: any;
    responseEstDetail: any,
    inventoryData: any,
    inventoryUniqueRow: any
}


class CubeSheetCard extends React.Component<CubeSheetCardrops, CubeSheetCardState> {
    private _isMounted: boolean = false
    sigCanvasFirst: any;
    sigCanvasSecond: any;
    firstSignPadRef: any;

    constructor(props: CubeSheetCardrops) {
        super(props);
        //debugger;
        this.state = {
            loading: true,
            transportData: [],
            responseEstDetail: {},
            inventoryData: [],
            inventoryUniqueRow: [],
            data: {
                t: "$6000",
                p: "$560",
                m: "$45678"
            }
        };


    }


    componentDidMount() {

        console.log("componentDidMount")

        //this.setState({loading:false});
        this._isMounted = true;
        var cid = (localStorage.getItem("CID") || "");
        var securetoken = localStorage.getItem("securetoken") || "";
        //this.getData(cid);
        Promise.all([
            //this.getCustomerDetails(cid),
            this.getEstFlowEstimateDetails(cid),
            this.getEstimatorInventory(cid)
        ]).then((response: any[]) => {
            if (this._isMounted) {
                const responseEstDetail = response[0][0];
                console.log("RESPONSE", responseEstDetail)
                this.setState({ responseEstDetail: responseEstDetail });
                //localStorage.setItem("estFlowEstimateDetails", JSON.stringify(responseEstDetail));
                var inventory = response[1];
                this.setState({ inventoryData: inventory });
                //localStorage.setItem("estInventory", JSON.stringify(inventory));

                var inventoryUniqueNames: any = [];
                const inventoryObj = this.state.inventoryData.filter((item: { name: any; }) => {
                    var idx = inventoryUniqueNames.findIndex((x: { name: any; }) => x.name == item.name);
                    if (idx <= -1) {
                        inventoryUniqueNames.push({ name: item.name });
                    }
                });
                console.log("UNIQUE", inventoryUniqueNames)
                this.setState({ inventoryUniqueRow: inventoryUniqueNames, loading: false });
            }
        });
        //this.setState({loading:false});
    }

    componentWillUnmount() {
        this._isMounted = false;
        console.log("componentWillUnmount")
    }

    async getCustomerDetails(cid: string, securetoken: string) {
        return await getCustomerDetails(cid, securetoken)
    }

    async getEstFlowEstimateDetails(cid: string) {
        return await getEstFlowEstimateDetails(cid)
    }

    async getEstimatorInventory(cid: string) {
        return await getEstimatorInventory(cid)
    }

    sumProperty(arr: any, type: any) {
        return arr.reduce((total: number, obj: any) => {
            if (typeof obj[type] === 'string') {
                return total + Number(obj[type].replace('$', ''));
                //return total + Number(obj[type]);
            }
            return total + obj[type].replace('$', '');
            //return total + obj[type];
        }, 0);
    }
    renderInventory() {
        const items = this.state.inventoryUniqueRow.map((item: any, index: number) => {

            var nestedData: any = [];
            var inventData = this.state.inventoryData.filter((itemObj: any) => {
                if (itemObj.name.match(item.name)) {
                    var obj = { type: itemObj.materialDescription, summary: itemObj.packingType, amount: itemObj.qTY, hour: '' }
                    nestedData.push(obj);
                    return obj;
                }
            });

            var totalQty = this.sumProperty(nestedData, 'amount');
            var totalLbs = this.sumProperty(inventData, 'cubeQTY');

            return <MoveListCard
                key={index}
                title={item.name}
                data={nestedData}
            />
        })

        return items;
    }

    render() {


        return (
            this.state.loading ? <Spinner /> :

                <div>

                    <CardLayout>
                        {this.renderInventory()}
                    </CardLayout>

                </div>
        );
    }
}

export default CubeSheetCard;